(function(){
       'use strict'; 
    jQuery(document).ready(function($) {
          function check_compare(value){
              for (var i = 1; i <=3; i++) {
                if (compare_list['p' + i] == value ) {
                    return true
                  break;
                } 
              }
              return false;
          }
          function readMore(string, maxWords) {       
              var strippedString = $("<p>" + string + "</p>").text().trim();      
              var array = strippedString.split(" ");
              var string = array.splice(0, maxWords).join(" ");

              if(array.length > maxWords) {
                string += "...";
              }

              return string ;
            }
            function roadtip(element) { 
              var tipText = element.html();
              element.bind('mouseover', function() {
                if (jQuery('.roadtip').length == 0) {
                  element.before('<span class="roadtip">' + tipText + '</span>');

                  var tipWidth = jQuery('.roadtip').outerWidth();
                  var tipPush = -(tipWidth / 2 - element.outerWidth() / 2);
                  jQuery('.roadtip').css('margin-left', tipPush);
                }
              });
              element.bind('mouseleave', function() { 
                jQuery('.roadtip').remove();
              });
            }
            function convert_currency(value,type){

                try{
                  var newCurrency = Currency.currentCurrency;
                }catch(ex){
                  var newCurrency = '';
                }
                try{
                  var oldCurrency = shopCurrency;
                }catch(ex){
                  var oldCurrency = '';
                }
                if(isNaN(value)){
                    value =  0.0; 
                }
 
                var cents = 0.0;
                var oldFormat = Currency.moneyFormats['USD'][ Currency.format] || '';
                var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
                if(type == 'format'){
                  return  Currency.formatMoney(value, newFormat);
                }
                if (oldFormat.indexOf('amount_no_decimals') !== -1) {
                    cents = Currency.convert(parseInt(value, 10)*100, oldCurrency, newCurrency);
                }
                else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
                    cents = Currency.convert(parseInt(value, 10)/10, oldCurrency, newCurrency);
                }
                else { 
                    cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
                }
                if(type  == 'nosymbol'){
                    return cents;
                }
                var my_data =  Currency.formatMoney(cents, newFormat);
                return my_data;
       
      }
      function get_symbol(value){
          var str = value.split("");
          var sym = '';
          for(var i=0;i<str.length;i++){
            if(isNaN(str[i])){
                sym+=str[i];
            }else{
              return sym; 
            }
          }
          return sym;
      }
function get_price_only(price){
       var  price_convert= price.toString();
        var get_currencies = 0;
         var $split = price_convert.split(';');
                if($split.length > 1){
                   get_currencies = (isNaN(parseInt( price_convert.substring(1,0)))) ?  $split[1]:  $split[0];
                }else{
                   get_currencies =price_convert.replace(/[^0-9.]/g, '');
                }
                get_currencies = $.trim(get_currencies); 
                var check = get_currencies.substring(1,0);
                if(isNaN((check))){
                get_currencies =   get_currencies.replace(check,'');
                }
          return parseFloat(get_currencies);

      }
      
      
      
      


        var max_price_slide = convert_currency(9999,'');
        var get_currencies = convert_currency(9999,'');
        var min_price_slide = convert_currency(0,'');
         
        var $split = get_currencies.split(';');
        if($split.length > 1){
           get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ?  $split[0]+';':  $split[1]+';';

        }else{
           get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ? get_symbol( get_currencies):   get_currencies.substring(1,-1);
        }

       
       $slider_filter = $('#slider-range').slider({
            range: true,
            min: get_price_only(min_price_slide),
            max: get_price_only(max_price_slide),
            values: [get_price_only(min_price_slide), get_price_only(max_price_slide)],
            slide: function(event, ui) {
                var max_price_slide = convert_currency(9999,'');
                var get_currencies = convert_currency(9999,'');
                var min_price_slide = convert_currency(0,'');
                var $split = get_currencies.split(';');
                if($split.length > 1){
                   get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ?  $split[0]+';':  $split[1]+';';

                }else{
                   get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ? get_symbol( get_currencies):   get_currencies.substring(1,-1);
                }
                var max_pr = get_currencies + ' ' + ui.values[1];
                var min_pr =  get_currencies +' ' + ui.values[0];

                $(".price_label .from span").html(min_pr);
                $(".price_label .to span").html(max_pr);
            },
            change: function(event, ui) {
              var view_mode = ($(".grid").hasClass('active')) ? '.grid' : '.list';
              $(".orderby").hide();
                $("#loading").show(0);
                var max_price = ui.values[1];
                var min_price =ui.values[0];
                 
                var check = 1;
                $(".shop-products").empty();
                // var view  =$(".change-view--active").data('view');
                var html = '';
                var has_product = false;
                $.each(json_collection_filter,function(index, elem) { 
                    if (check <= 12) {
                        var current_price =  convert_currency(elem.price,'');
                        current_price = get_price_only(current_price);
                        if (current_price <= max_price && current_price >= min_price) {
                          has_product = true;
                         html +=   json_to_html(elem);
                        }
                    }
                    check++;
                });
                if(! has_product){
                  html +='<p class="text-center"> No products were found matching your selection.</p>';
                }
                $(".shop-products").append(html);
                $(view_mode).trigger('click');
                      //Tooltip
                  $('.yith-wcwl-add-button a').each(function() {
                    roadtip($(this));
                  });
                  $('.compare-button a').each(function() {
                    roadtip($(this));
                  });
                  $('.add-to-cart a').each(function() {
                    roadtip($(this));
                  });
                  $('.detail-link.quickview .fa').each(function() {
                    roadtip($(this));
                  });
                window.setTimeout(function() {
                     $("#loading").hide(700);
                }, 1000);
            } 
        });
        // $("#amount").val("$" + $("#slider-range").slider("values", 0) +
        //     " — $" + $("#slider-range").slider("values", 1));

        
        function json_to_html(product){
         // shop-products
         var $html = '';
              $html +='<div class="item-col col-xs-12 col-sm-3">';
              $html +='<div class="product-wrapper">';
              $html +=' <div class="list-col4 col-xs-12 col-sm-3">';
              $html +='<div class="product-image">';
              $html +='<a class="image-link" href="product-single.html" title="Aliquam lobortis est">';
              $html +='<img src="'+product.featured_image+' class="primary_image" alt="'+product.title+'" />';
              if(product.images.length > 1)
              {
                $html +='<img src="'+product.images[1]+'" class="secondary_image" alt="s10"/>';
              }
              $html +='<span class="shadow"></span> ';
              $html +='</a>';
              $html +='<a data-pid="'+product.variants[0].id +'"  data-handle="'+product.handle+'" class="detail-link quickview" href="" title="'+product.title+'" data-toggle="modal" data-target="#productModal">';
              $html +='<span class="square"></span><i class="fa fa-eye">Quick View</i>';
              $html +='</a>';
              $html +='<div class="actions">';
              $html +='<div class="action-buttons">';
              $html +='<div class="add-to-links">';
              $html +='<div class="yith-wcwl-add-to-wishlist">';
              $html +='<div class="yith-wcwl-add-button show"> ';
              if(is_customers){
                if(jQuery.inArray(product.id, json_wishlist ) >= 0){
                  $html+=' <div class="yith-wcwl-add-button yith-wcwl-wishlistexistsbrowse show">';
                  $html +=' <a href="/collections/wishlist" class="view-added-wishlist add_to_wishlist" >View my Wishlist</a>';
                  $html +='</div>';
                  }else{
                    $html +='<a class="add_to_wishlist wishlist" href="" data-pid="'+product.handle+'" data-form="'+product.id+'"> Add to Wishlists</a>';
                      $html +='<a href="/collections/wishlist" class="yith-wcwl-wishlistaddedbrowse added-wishlist"  data-toggle="tooltip" data-placement="top" >Added to wishlist</a>';
                  }
                }else {
                    $html += '<a class="wishlist-login add_to_wishlist"   href="javascript:void(0)">Login to use wishlist</a>';
                  }
              $html +='</div>'; 
              $html +=' </div>'; 
              $html +='<div class="clear"></div>';
              $html +='<div class="woocommerce product compare-button">';
              if(check_compare(product.handle)){
                $html +='    <a class="compare added" href="" data-pid="'+product.handle+'">Added to Compare</a>';
              }else{
                $html +='    <a class="compare" href="" data-pid="'+product.handle+'">Add to Compare</a>';
              }
              $html +=' </div>';
              $html +=' </div>';
              $html +='<div class="add-to-cart">';
              $html +='<p class="product woocommerce add_to_cart_inline ">';
              $html +='<a href="" class="button add_to_cart_button " data-pid="'+product.variants[0].id+'">Add to cart</a>';
              $html +='</p>';
              $html +='</div>';
              $html +='</div>';
              $html +='</div>';
              $html +='</div>';
              $html +='</div>';
              $html +='<div class="list-col8 col-xs-12 col-sm-9">';
              $html +='<h2 class="product-name-listview"><a href="/products/'+product.handle+'">'+product.title+'</a></h2>';
              // $html +=' <div class="ratings">';
              // $html +='<div class="star-rating" title="Rated 5.00 out of 5">';
              // $html +='<span style="width:100%">';
              // $html +='    <strong class="rating">5.00</strong> out of 5';
              // $html +='   </span>';
              // $html +='  </div>';
              // $html +=' </div>';
              $html +='  <div class="price-box">';
              $html +='    <span class="special-price">';
              $html +='     <span class="amount" > <span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.price,'xx')+'">'+convert_currency(product.price,'xx')+'</span></span>';
              $html +='     </span>';
              if(convert_currency(product.compare_at_price,'nosymbol') > 0)
                $html+='<span class="old-price"> <span class="amount"> <span class="money" data-currency-'+Currency.currentCurrency+'='+convert_currency(product.compare_at_price,'xx')+'</span>  </span> </span>';
              
              $html +=' </div>';
              $html +=' <div class="product-desc">';
              $html +='   <p>'+  readMore(product.content, 50) +'</p>';
              $html +=' </div>';
              $html +='  <div class="actions actions-listview">';
              $html +='   <div class="action-buttons">';
              $html +='   <div class="add-to-links">';
              $html +='   <div class="yith-wcwl-add-to-wishlist add-to-wishlist-1164">';
              $html +='     <div style="display:block" class="yith-wcwl-add-button show">';
                if(is_customers){
                if(jQuery.inArray(product.id, json_wishlist ) >= 0){
                  $html+=' <div class="yith-wcwl-add-button yith-wcwl-wishlistexistsbrowse show">';
                  $html +=' <a href="/collections/wishlist" class="view-added-wishlist add_to_wishlist" >View my Wishlist</a>';
                  $html +='</div>';
                  }else{
                    $html +='<a class="add_to_wishlist wishlist" href="" data-pid="'+product.handle+'" data-form="'+product.id+'"> Add to Wishlists</a>';
                      $html +='<a href="/collections/wishlist" class="yith-wcwl-wishlistaddedbrowse added-wishlist"  data-toggle="tooltip" data-placement="top" >Added to wishlist</a>';
                  }
                }else {
                    $html += '<a class="wishlist-login add_to_wishlist"   href="javascript:void(0)">Login to use wishlist</a>';
                  }
            
              
              $html +='     </div>';
              $html +='   </div>';
              $html +='   <div class="woocommerce product compare-button">';
              if(check_compare(product.handle)){
                $html +='    <a class="compare added" href="" data-pid="'+product.handle+'">Added to Compare</a>';
              }else{
                $html +='    <a class="compare" href="" data-pid="'+product.handle+'">Add to Compare</a>';
              }
              $html +='    </div>';
              $html +='  </div>';
              $html +='  <div class="add-to-cart">';
              $html +='    <p class="product woocommerce add_to_cart_inline">';
              if (product.variants.length > 1){
                $html +='     <a class="button add_to_cart_button product_type_variable" href="/products/'+product.handle+'">Select options</a>';
              }else{ 
                $html +='     <a class="button add_to_cart_button " data-pid="'+product.variants[0].id+'" href="">Add to cart</a>';
              }
              $html +='      </p>';
              $html +='    </div>';
              $html +='  </div>';
              $html +=' </div>';
              $html +='</div>';
              $html +='<div class="clearfix"></div>';
              $html +='</div>';
              $html +='</div>';

              return $html ;
        }
     
      //  $("#amount").val(Currency.currentCurrency + " " + $("#slider-range").slider("values", 0) + " - " + Currency.currentCurrency +" "+ $("#slider-range").slider("values", 1));
    });
    })(jQuery);